import request from '../../utils/request';
import { Result } from '../../models/general';
import {
  EmployeeHealthInsuranceView,
  EmployeeHealthInsuranceInput,
  CchiTierScheduleView,
  CchiTierScheduleInput,
  CchiPanelData,
} from '../../models/payroll';

export async function getCchiPolicy(userId: string): Promise<Result<EmployeeHealthInsuranceView>> {
  const response = await request.get<Result<EmployeeHealthInsuranceView>>(
    `Payroll/Cchi/employee/${encodeURIComponent(userId)}`,
  );
  return response.data;
}

export async function upsertCchiPolicy(
  userId: string,
  input: EmployeeHealthInsuranceInput,
): Promise<Result<EmployeeHealthInsuranceView>> {
  const response = await request.put<Result<EmployeeHealthInsuranceView>>(
    `Payroll/Cchi/employee/${encodeURIComponent(userId)}`,
    input,
  );
  return response.data;
}

export async function archiveCchiPolicy(policyId: number): Promise<Result<boolean>> {
  const response = await request.delete<Result<boolean>>(`Payroll/Cchi/employee/${policyId}`);
  return response.data;
}

export async function uploadCchiPolicyDocument(
  userId: string,
  file: File,
): Promise<Result<{ url: string }>> {
  const form = new FormData();
  form.append('file', file);
  const response = await request.post<Result<{ url: string }>>(
    `Payroll/Cchi/employee/${encodeURIComponent(userId)}/document`,
    form,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return response.data;
}

export async function listCchiTierSchedules(): Promise<Result<CchiTierScheduleView[]>> {
  const response = await request.get<Result<CchiTierScheduleView[]>>('Payroll/Cchi/tier-schedules');
  return response.data;
}

export async function createCchiTierSchedule(
  input: CchiTierScheduleInput,
): Promise<Result<CchiTierScheduleView>> {
  const response = await request.post<Result<CchiTierScheduleView>>('Payroll/Cchi/tier-schedules', input);
  return response.data;
}

export async function updateCchiTierSchedule(
  id: number,
  input: CchiTierScheduleInput,
): Promise<Result<CchiTierScheduleView>> {
  const response = await request.put<Result<CchiTierScheduleView>>(`Payroll/Cchi/tier-schedules/${id}`, input);
  return response.data;
}

export async function archiveCchiTierSchedule(id: number): Promise<Result<boolean>> {
  const response = await request.delete<Result<boolean>>(`Payroll/Cchi/tier-schedules/${id}`);
  return response.data;
}

export async function getCchiPanel(): Promise<Result<CchiPanelData>> {
  const response = await request.get<Result<CchiPanelData>>('Payroll/Cchi/panel');
  return response.data;
}
